var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper",style:({ 'background-image' : _vm.imgBg ? 'url(' + _vm.imgBg + ')' : 'none', 
            'background-color' : _vm.bgColor ? _vm.bgColor : 'transparent',
            'color': _vm.color ? _vm.color : '#444444' })},[_c('div',{staticClass:"page-content-wrapper",style:({ 'flex-direction' : _vm.direction ? _vm.direction : 'row'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }